module.exports = __webpack_public_path__ + "static/media/medicall24logo.8a47178c.png";